
<template>
  <v-container class="grey lighten-5">
    <div class="mb-5">
      <v-btn icon :to="{ path: '/' }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="display-1 px-3">よくあるご質問（FAQ）</span>
    </div>
    <v-card class="pa-4">
      <v-card-title>OilMatrix ジャパン・アナリストに関するご質問です</v-card-title>
      <v-expansion-panels accordion>
      <v-expansion-panel v-for="items of FAQList" v-bind:key=items.id>
        <v-expansion-panel-header class="justify-self-start body-2">
          <div>
            <v-icon small>mdi-help-circle-outline</v-icon>
            <span v-html="items.Question"></span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="py-6 teal lighten-5">
          <span v-html="items.Answer"></span>
        </v-expansion-panel-content>
      </v-expansion-panel>
     </v-expansion-panels>

    <v-row dense justify="center">
    <v-col cols="12" md="6">
    <v-card flat outlined class="pa-4 my-10 text-center">
      <div class="font-weight-bold grey--text text--darken-1 mb-5">さらにサポートが必要な場合はお問合せください</div>
      <v-btn rounded color="body-2 amber darken-1 font-weight-bold" block  @click="openInquiry()" class="mx-2 mb-5">
        <v-icon class="mr-2">mdi-comment-question-outline  </v-icon>お問合わせ
      </v-btn>
      </v-card>
    </v-col>
    </v-row>

    </v-card>
  </v-container>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { sortedlistFAQs } from '../graphql/queries'

export default {
  name: 'faqList',
  data() {
    return {
      FAQList: [],
//      inquiry_url: process.env.VUE_APP_INQUIRY_URL,
      inquiry_url: "https://www.japan-analysts.com/contact/",
    }
  },
  mounted: async function () {
    let FAQs = await API.graphql(graphqlOperation(sortedlistFAQs, {limit: 100, isActive: '1' }))
    this.FAQList = FAQs.data.sortedlistFAQs.items
    console.log("FAQs:",this.FAQList);

  },
  computed : {
  },
  methods: {
    openInquiry() {
        window.open(this.inquiry_url, '_blank')
    },
  },
}
</script>